import { render, staticRenderFns } from "./product-detail.vue?vue&type=template&id=4eef3f6c&scoped=true"
import script from "./product-detail.vue?vue&type=script&lang=js"
export * from "./product-detail.vue?vue&type=script&lang=js"
import style0 from "./product-detail.vue?vue&type=style&index=0&id=4eef3f6c&prod&lang=less"
import style1 from "./product-detail.vue?vue&type=style&index=1&id=4eef3f6c&prod&scoped=true&lang=less"
import style2 from "@/assets/h5css/mobile/product-detail.less?vue&type=style&index=2&id=4eef3f6c&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eef3f6c",
  null
  
)

export default component.exports